/* eslint-disable
    consistent-return
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS205: Consider reworking code to avoid use of IIFEs
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import _ from 'underscore';

import {assert} from 'Asserts';

function siteInsideFragment(sequence, enzyme, {start, end, cutsites}) {
  assert(enzyme.get('cut') !== 0, `enzyme=${enzyme.get('id')} cuts at its recognition site`);
  assert(start != null || end != null, `Both start=${start} and end=${end} are not defined`);
  const position = (() => {
    if (start != null) {
      return start;
    } else if (end != null) {
      return end;
    }
  })();
  assert(
    _.findWhere(cutsites, {position}) != null,
    `enzyme=${enzyme.get('id')} \
cutsites=${JSON.stringify(cutsites)} don't include start=${start} or end=${end}`
  );
  // Find the strand that corresponds to the cutsite being inside the fragment. For example, if the
  // BbsI cutsite at the fragment start is on the reverse strand, then the recognition site is
  // inside the fragment.
  //
  //     AGTAAAGTCTTC
  //     TCATTTCAGAAG
  //     ^          ^
  //   start   recog. site
  const siteInsideFragmentStrand = (() => {
    if (start != null) {
      if (enzyme.get('cut') > 0) {
        return -1;
      } else {
        return 1;
      }
    } else if (end != null) {
      if (enzyme.get('cut') > 0) {
        return 1;
      } else {
        return -1;
      }
    }
  })();
  return _.findWhere(cutsites, {position, strand: siteInsideFragmentStrand}) != null;
}

function getSitesInsideFragmentWarning(sequence, enzyme, {start, end, cutsites}) {
  const atStart = start != null ? siteInsideFragment(sequence, enzyme, {start, cutsites}) : undefined;
  const atEnd = end != null ? siteInsideFragment(sequence, enzyme, {end, cutsites}) : undefined;
  if (atStart && atEnd) {
    let warning = 'Recognition sites are inside fragment.';
    if (sequence.circular()) {
      warning += ' Flip start and end.';
    }
    return warning;
  }
  if (atStart) {
    return 'Start recognition site is inside fragment.';
  }
  if (atEnd) {
    return 'End recognition site is inside fragment.';
  }
  return null;
}

export {getSitesInsideFragmentWarning, siteInsideFragment};
